import { DataType, TableName } from "../../../../tables"
import { ArchiveModal } from "./archiveModal"

type Props = {
    tableName: TableName
    dataType?: DataType
}

export const DirectArchiveModal = (props: Props) => {
    const { tableName, dataType } = props

    return <ArchiveModal
        tableName={tableName}
        dataType={dataType}
        directAction
    />
}
